import React, {Fragment} from "react";
import {ApiUtility} from "../common/ApiUtility";
import {useModelFormEngine} from "../common/hooks/useModelFormEngine";
import {ConditionalRenderer} from "../common/ConditionalRenderer";
import {OverlayLoadingIndicator} from "../common/OverlayLoadingIndicator";
import {PillButton} from "../common/PillButton";

import _ from "lodash";
import Select from 'react-select';
import {SelectUtility} from "../common/SelectUtility";

export const InvoicePaymentSettingsForm = function (props) {
    const invoicePaymentSettings = _.clone(props.invoicePaymentSettings) || {};

    let initialModelState = {
        ext_qbo_payment_bank_account_id: invoicePaymentSettings.ext_qbo_payment_bank_account_id,
        ext_qbo_stripe_balance_account_id: invoicePaymentSettings.ext_qbo_stripe_balance_account_id,
        ext_qbo_default_merchant_fee_account_id: invoicePaymentSettings.ext_qbo_default_merchant_fee_account_id,
    };

    const fetchSupportingData = function () {
        let qboAccountOptions = []
        let qboBankAccountOptions = []
        return ApiUtility.getQboAccountsList()
            .then(function (qboAccounts) {
                qboAccountOptions = SelectUtility.modelArrayToSelectOptions(qboAccounts)
                qboBankAccountOptions = SelectUtility.modelArrayToSelectOptions(
                    qboAccounts.filter((qboAccount) => qboAccount.type === 'Bank')
                )

                return Promise.resolve({
                    supportingData: {
                        qboAccountOptions: qboAccountOptions,
                        qboBankAccountOptions: qboBankAccountOptions
                    }
                });
            })
    }

    const formEngine = useModelFormEngine(
        initialModelState,
        invoicePaymentSettings,
        fetchSupportingData,
        validateForm,
        formStateToSaveData,
        props.save
    );

    function validateForm(handleValidationResult) {
        return new Promise(function (resolve, reject) {
            let validationErrors = [];
            let invalidFields = [];

            Promise.resolve({})
                .then(function () {
                    if (!formEngine.renderableData.ext_qbo_payment_bank_account_id) {
                        validationErrors.push('Please select where Stripe payments are deposited.');
                        invalidFields.push('ext_qbo_payment_bank_account_id');
                    }

                    if (!formEngine.renderableData.ext_qbo_stripe_balance_account_id) {
                        validationErrors.push('Please select account for Stripe balance.');
                        invalidFields.push('ext_qbo_stripe_balance_account_id');
                    }

                    if (!formEngine.renderableData.ext_qbo_default_merchant_fee_account_id) {
                        validationErrors.push('Please select a default merchant fee account.');
                        invalidFields.push('ext_qbo_default_merchant_fee_account_id');
                    }

                    return handleValidationResult(validationErrors, invalidFields, resolve);
                });
        });
    }

    function formStateToSaveData(formStateToTransform) {
        let saveData = _.clone(formStateToTransform);
        return saveData;
    }

    function handleQboAccountChange(fieldName, option) {
        formEngine.updateAndRenderUnsavedData({[fieldName]: option.value});
    }

    return (
        <Fragment>
            <ConditionalRenderer
                if={formEngine.renderableData.showOverlayLoadingIndicator || !formEngine.renderableData.supportingData}
                renderer={() => (
                    <OverlayLoadingIndicator/>
                )}
            />
            <ConditionalRenderer if={formEngine.renderableData.supportingData} renderer={() => (
                <div className="common-form invoice-payment-settings-form">
                    <div className="common-form-body">
                        <div className="common-form-body-row qbo-account-select-row">
                            <div
                                className={formEngine.getFormFieldClasses(
                                    "common-form-field",
                                    "ext_qbo_payment_bank_account_id"
                                )}
                            >
                                <div className="common-form-field-label">
                                    Where are Stripe payouts deposited?
                                </div>
                                <div className="common-form-field-input-container">
                                    <Select
                                        className="common-form-select qbo-account-select payout-deposit-account-select"
                                        classNamePrefix="common-form-select"
                                        value={SelectUtility.selectOptionForId(
                                            formEngine.renderableData.ext_qbo_payment_bank_account_id,
                                            formEngine.renderableData.supportingData.qboBankAccountOptions
                                        )}
                                        onChange={(option) => handleQboAccountChange(
                                            'ext_qbo_payment_bank_account_id',
                                            option
                                        )}
                                        options={formEngine.renderableData.supportingData.qboBankAccountOptions}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="common-form-body-row qbo-account-select-row">
                            <div
                                className={formEngine.getFormFieldClasses(
                                    "common-form-field",
                                    "ext_qbo_stripe_balance_account_id"
                                )}
                            >
                                <div className="common-form-field-label">
                                    {`Which account will track your Stripe balance? (Pick the Undeposited Funds account or this will not work)`}
                                </div>
                                <div className="common-form-field-input-container">
                                    <Select
                                        className="common-form-select qbo-account-select stripe-balance-account-select"
                                        classNamePrefix="common-form-select"
                                        value={SelectUtility.selectOptionForId(
                                            formEngine.renderableData.ext_qbo_stripe_balance_account_id,
                                            formEngine.renderableData.supportingData.qboAccountOptions
                                        )}
                                        onChange={(option) => handleQboAccountChange(
                                            'ext_qbo_stripe_balance_account_id',
                                            option
                                        )}
                                        options={formEngine.renderableData.supportingData.qboAccountOptions}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="common-form-body-row qbo-account-select-row">
                            <div
                                className={formEngine.getFormFieldClasses(
                                    "common-form-field",
                                    "ext_qbo_default_merchant_fee_account_id"
                                )}
                            >
                                <div className="common-form-field-label">
                                    Default merchant fee account
                                </div>
                                <div className="common-form-field-input-container">
                                    <Select
                                        className="common-form-select qbo-account-select merchant-fee-account-select"
                                        classNamePrefix="common-form-select"
                                        value={SelectUtility.selectOptionForId(
                                            formEngine.renderableData.ext_qbo_default_merchant_fee_account_id,
                                            formEngine.renderableData.supportingData.qboAccountOptions
                                        )}
                                        onChange={(option) => handleQboAccountChange(
                                            'ext_qbo_default_merchant_fee_account_id',
                                            option
                                        )}
                                        options={formEngine.renderableData.supportingData.qboAccountOptions}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="common-form-body-row">
                            <div className="common-form-options">
                                <PillButton
                                    onClick={formEngine.onClickSave}
                                    containerClasses="common-form-button-container"
                                    buttonClasses="common-form-button save-button"
                                    buttonText={"SAVE"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}/>
        </Fragment>
    );
}
